import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useStartAPetitionPageState } from 'src/app/pages/startAPetitionV2/pageContext';

type Flow = 'with_ai' | 'write_my_own';

type UseIntroResult = ModelHookResult<{ copyVariant: 'variant' | 'control' }, { submit: (flow: Flow) => void }>;

export function useIntro(): UseIntroResult {
	const { data, actions } = useStartAPetitionPageState();
	const track = useTracking();

	const isRecommendedAnglesExperiment = data.draft?.metadata?.variant === 'recommendations';

	const submit = useCallback(
		(flow: Flow) => {
			void track('sap_intro_submit', { cta: flow });

			if (flow === 'write_my_own') {
				const hasUserDraft = !!(data.draft?.petitionDraft && !data.draft.recommendedDraft);
				const draft = !hasUserDraft
					? { recommendedDraft: null, petitionDraft: null, metadata: { imageJobId: null } }
					: {};
				actions.send({ type: 'submit', target: 'user', draft });
				return;
			}

			actions.send({ type: 'submit', target: 'ai' });
		},
		[actions, data.draft, track],
	);

	return {
		data: {
			copyVariant: isRecommendedAnglesExperiment ? 'variant' : 'control',
		},
		actions: {
			submit,
		},
	};
}
